module.exports = {"620321100":"城关镇","620321101":"河西堡镇","620321102":"新城子镇","620321103":"朱王堡镇","620321104":"东寨镇","620321105":"水源镇","620321200":"红山窑乡","620321201":"焦家庄乡","620321202":"六坝乡","620321203":"南坝乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/620321.json
// module id = 2689
// module chunks = 0